import { Typography } from "@mui/material";
import { Box, Container, padding, Stack } from "@mui/system";
import React from "react";

function SectionTitle({ number, children }) {
  return (
    <Typography variant="h5" marginBottom={1}>
      {number}. <span style={{ textDecoration: "underline" }}>{children}</span>
    </Typography>
  );
}

function PolicyText({ children }) {
  return <Typography variant="body">{children}</Typography>;
}

function TermsAndConditions() {
  return (
    <Stack
      padding={0}
      style={{
        position: "absolute",
        top: "90px",
        left: "0px",
      }}
    >
      <Typography variant="h2" textAlign="center" margin={{ xs: 3, md: 4 }}>
        ATS Terms and Conditions
      </Typography>
      <Stack spacing={4} margin={{ xs: 3, md: 4 }} padding={{ xs: 1, md: 2 }}>
        <Box>
          <SectionTitle number="1"> Introduction</SectionTitle>
          <PolicyText>
            Welcome to EFIQ ATS, an attendance management system developed by
            EFIQ Solutions. By accessing or using this application, you agree to
            comply with and be bound by these Terms and Conditions. If you do
            not agree with any part of these terms, you must not use the
            application.
          </PolicyText>
        </Box>

        <Box>
          <SectionTitle number="2"> Purpose of the Application</SectionTitle>
          <PolicyText>
            This application is designed to simplify employee attendance
            tracking, working hours calculation, and report generation for
            organizations. It is intended only for authorized employees and
            administrators of the respective company.
          </PolicyText>
        </Box>

        <Box>
          <SectionTitle number="3"> User Responsibilities</SectionTitle>
          <PolicyText>
            Users must use the app only for legitimate attendance-related
            purposes. Users are responsible for maintaining the confidentiality
            of their login credentials. Any misuse of login information or
            falsification of attendance (e.g., fake check-ins, proxy logins) is
            strictly prohibited. Users must ensure accurate data input and
            promptly report any discrepancies to their HR or system
            administrator.
          </PolicyText>
        </Box>

        <Box>
          <SectionTitle number="4"> Data Collection & Privacy</SectionTitle>
          <PolicyText>
            The application may collect personal information such as employee
            ID, location data (if GPS-based check-in is enabled), attendance
            time, and device details. Data is stored securely and used solely
            for organizational attendance and reporting purposes. EFIQ Solutions
            will not share, sell, or rent user data to any third party without
            authorization, except as required by law By using the app, users
            consent to such data collection and storage practices.
          </PolicyText>
        </Box>

        <Box>
          <SectionTitle number="5"> Accuracy of Information</SectionTitle>
          <PolicyText>
            While EFIQ Solutions takes all reasonable steps to ensure system
            accuracy, errors may occur due to technical or network issues. In
            such cases, users should report issues immediately for correction.
            The company will not be liable for missed attendance or payroll
            discrepancies resulting from user negligence or network failure.
          </PolicyText>
        </Box>

        <Box>
          <SectionTitle number="6"> System Access & Availability</SectionTitle>
          <PolicyText>
            The company may temporarily suspend access to the app for
            maintenance or updates. The app requires an active internet
            connection and device compatibility for optimal performance. EFIQ
            Solutions is not responsible for downtime due to third-party network
            failures or device limitations.
          </PolicyText>
        </Box>

        <Box>
          <SectionTitle number="7"> Intellectual Property</SectionTitle>
          <PolicyText>
            All intellectual property rights in the app, including its code,
            design, and features, are owned by EFIQ Solutions. Users are not
            permitted to modify, copy, distribute, or reverse-engineer any part
            of the system.
          </PolicyText>
        </Box>

        <Box>
          <SectionTitle number="8"> Termination of Access</SectionTitle>
          <PolicyText>
            The company reserves the right to suspend or terminate user access
            at any time for violation of these terms or misuse of the system.
          </PolicyText>
        </Box>

        <Box>
          <SectionTitle number="9"> Liability Limitation</SectionTitle>
          <PolicyText>
            EFIQ Solutions shall not be held liable for any direct, indirect,
            incidental, or consequential damages arising out of the use or
            inability to use the app. Users acknowledge that the app is provided
            “as-is” without any express or implied warranties.
          </PolicyText>
        </Box>

        <Box>
          <SectionTitle number="10"> Modifications to Terms</SectionTitle>
          <PolicyText>
            EFIQ Solutions reserves the right to modify these Terms and
            Conditions at any time. Updated versions will be notified to users
            via in-app message or email.
          </PolicyText>
        </Box>

        <Box>
          <SectionTitle number="11"> Governing Law</SectionTitle>
          <PolicyText>
            These Terms shall be governed by and construed in accordance with
            the laws of India. Any disputes arising under these terms will be
            subject to the exclusive jurisdiction of the courts located in
            Paramakudi.
          </PolicyText>
        </Box>

        <Box>
          <SectionTitle number="12">Contact Information</SectionTitle>
          <PolicyText>
            For any questions, feedback, or concerns regarding these Terms and
            Conditions, please contact: [support@efiqsolutions.com]
          </PolicyText>
        </Box>
      </Stack>
    </Stack>
  );
}

export default TermsAndConditions;
